import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import HomeIcon from '@mui/icons-material/HomeOutlined';
import SettingsIcon from '@mui/icons-material/SettingsOutlined';
import DesktopMacIcon from '@mui/icons-material/DesktopMac';
import MapIcon from '@mui/icons-material/Map';
import AssignmentIcon from '@mui/icons-material/Assignment';
import DeveloperBoardIcon from '@mui/icons-material/DeveloperBoard';
import PhishingRoundedIcon from '@mui/icons-material/PhishingRounded';
import BrandingWatermarkIcon from '@mui/icons-material/BrandingWatermark';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import AddRoadIcon from '@mui/icons-material/AddRoad';
import config from '../../../../configuration/configuration.js';

export default [
	{
		title: '',
		pages: [
			{
				title: 'Home',
				href: '/home',
				icon: HomeIcon,
				// roles: ['Administrator', ...]
				// projects: ['Operations'],
			},
		],
	},
	{
		title: 'Modules',
		pages: [
			{
				title: 'Failures Tracker',
				href: '/modules/failuresTracker/0',
				roles: ['Administrator', 'Manager', 'CelfinetHQ'],
				icon: AssignmentIcon
			},
			{
				title: 'Dual Map',
				href: '/modules/dualMap',
				roles: ['Administrator', 'Manager', 'CelfinetHQ'],
				icon: MapIcon
			},
			{
				title: 'PDF Repository',
				href: '/modules/repositoryPdf',
				roles: ['Administrator', 'Manager', 'CelfinetHQ'],
				icon: BrandingWatermarkIcon
			},
			{
				title: 'Excel Repository',
				href: '/modules/repositoryExcel',
				roles: ['Administrator', 'Manager', 'CelfinetHQ'],
				icon: FileCopyIcon
			},
			{
				title: 'Drive Test Upload',
				href: '/modules/driveTestUpload',
				roles: ['Administrator', 'Manager'],
				icon: AddRoadIcon
			},
			// 		{
			// 			title: 'Site Optimizations',
			// 			href: '/modules/siteOptTracker',
			// 			icon: DeveloperBoardIcon
			// 		},
			// 		{
			// 			title: 'Dashboards',
			// 			// href: '/modules',
			// 			icon: PhishingRoundedIcon,
			// 			children: [
			// 				{
			// 					title: 'Failure Overview',
			// 					href: '/modules/dashboard1',
			// 				},
			// 				{
			// 					title: 'GEO Tracking',
			// 					href: '/modules/dashboard2',
			// 				},
			// 				{
			// 					title: 'Network Audit',
			// 					href: '/modules/dashboard3',
			// 				},
			// 				{
			// 					title: 'City Quality Assurance',
			// 					href: '/modules/dashboard4',
			// 				},
			// 				{
			// 					title: '5G Cell Count',
			// 					href: '/modules/dashboard5',
			// 				},
			// 				{
			// 					title: ' DSS Utilization',
			// 					href: '/modules/dashboard6',
			// 				},
			// 				{
			// 					title: 'OSS KPI Dashboard',
			// 					href: '/modules/dashboard7',
			// 				},
			// 			],
			// 		},
		],
	},
	{
		title: 'Management',
		pages: [
			{
				title: 'Manage',
				href: '/management',
				roles: ['Administrator', 'Manager'],
				icon: SupervisorAccountIcon,
				children: [
					{
						title: 'Operators',
						href: '/management/operators',
					},
					{
						title: 'Users',
						href: '/management/users',
					}
				],
			},
			{
				title: 'Hangfire',
				href: `${config.API_URL}hangfire?access_token={token}`,
				target: '_blank',
				roles: ['Administrator'],
				icon: DesktopMacIcon
			},
			{
				title: 'Settings',
				href: '/management/settings',
				icon: SettingsIcon
			},
		],
	}
];
